// extracted by mini-css-extract-plugin
module.exports = {"selfEvaluation":"antd-pro-pages-home-supervision-self-my-self-evaluation-index-selfEvaluation"};